import OrganizationUserEditPage from "@/features/organization/pages/OrganizationUserEdit";

const OrganizationUserEdit = () => {
  return <OrganizationUserEditPage />;
};

export default OrganizationUserEdit;
